module.exports = __webpack_public_path__ + "media/images/sankro-a45ebee1a6e2534836c969f2e12a85d8.PNG";